import create from 'zustand';
import { persist } from 'zustand/middleware';
import { jwtDecode } from "jwt-decode";

export interface IAccessTokenStore {
  secret: {
    // Data is always stored as string
    edge_access_token?: string
    expires_at?: string
  },
  getAccessToken: () => { accessToken?: string, expires?: Date },
  setAccessToken: (token: string) => void,
  removeAccessToken: () => void,
}

export const useAccessTokenStore = create<IAccessTokenStore>(
  persist(
    (setState, getState) => ({
      secret: {},
      getAccessToken: () => {
        const accessToken = getState().secret.edge_access_token;
        if (accessToken) {
          return {
            accessToken: accessToken,
            expires: new Date(jwtDecode(accessToken).exp! * 1000)
          }
        }
        return {};
      },
      setAccessToken: (token) => setState({
        secret: {
          edge_access_token: token
        }
      }),
      removeAccessToken: () => setState({ secret: {} })
    }),
    {
      name: 'access-token-storage', // Name of the item in storage (must be unique)
      getStorage: () => localStorage, // (optional) by default, 'localStorage' is used
    }
  )
);
